export default [
    {
        path: 'products',
        component: require('@/layouts/content/products').default,
        name: 'admin.products',
        redirect: to => {
            return {
                name: 'admin.products.index'
            }
        },
        children: [
            /** Products */
            {
                path: '/',
                name: 'admin.products.index',
                component: require('@/views/admin/products/products/index').default,
                meta: {
                    auth: {
                        roles: ['manage-products']
                    }
                }
            },
            {
                path: 'create',
                name: 'admin.products.create',
                component: require('@/views/admin/products/products/form').default,
                meta: {
                    mode: 'create',
                    auth: {
                        roles: ['manage-products']
                    }
                }
            },
            {
                path: ':id',
                name: 'admin.products.edit',
                component: require('@/views/admin/products/products/form').default,
                meta: {
                    mode: 'edit',
                    auth: {
                        roles: ['manage-products']
                    }
                }
            },
        ]
    }
]